import { render, staticRenderFns } from "./CardGestionVotantes.vue?vue&type=template&id=549dd6ea&scoped=true"
import script from "./CardGestionVotantes.vue?vue&type=script&lang=js"
export * from "./CardGestionVotantes.vue?vue&type=script&lang=js"
import style0 from "./CardGestionVotantes.vue?vue&type=style&index=0&id=549dd6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549dd6ea",
  null
  
)

export default component.exports